const addToCartButtons = document.querySelectorAll('.awo-add-product-button');

if (addToCartButtons.length > 0) {
  addToCartButtons.forEach(button => {
    // Existing click event listener
    button.addEventListener('click', async () => {
      const loader = button.querySelector('.loader-small');
      loader.style.display = 'inline-block';
      const variant = button.dataset.variant;
      // const inventoryStatus = button.dataset.inventoryStatus;
      const inventoryStatus = '';
      const properties = {
        Variant: variant,
        _InventoryStatus: inventoryStatus
      };
      try {
        await addProduct(variant, properties);
      } finally {
        loader.style.display = 'none'; // Hide the loader once the request is finished
      }
    });

    // New keydown event listener for keyboard accessibility
    button.addEventListener('keydown', async (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Prevent the default action for Enter and Space keys
        const loader = button.querySelector('.loader-small');
        loader.style.display = 'inline-block';
        const variant = button.dataset.variant;
        const inventoryStatus = button.dataset.inventoryStatus;
        const properties = {
          Variant: variant,
          _InventoryStatus: inventoryStatus
        };
        try {
          await addProduct(variant, properties);
        } finally {
          loader.style.display = 'none'; // Hide the loader once the request is finished
        }
      }
    });
  });
}

async function addProduct(variantId, properties) {
  const storedData = JSON.parse(localStorage.getItem('product_services')) || {};
  const items = [
    {
      id: variantId,
      quantity: 1,
      properties: properties
    }
  ];

  if (storedData[variantId] && storedData[variantId].selected_product_services.length > 0) {
    const selectedServices = storedData[variantId].selected_product_services;

    // Append each selected service to items array
    selectedServices.forEach(serviceId => {
      // Check if this service is a warranty by looking for the warranty-service-row
      const serviceElement = document.querySelector(
        `.warranty-service-row [data-service-id="${serviceId}"]`
      )?.closest('.warranty-service-row');
      
      let serviceProperties = {
        Parent: variantId
      };

      // Only add warranty properties if this is a warranty service
      if (serviceElement) {
        const warrantyPriceElement = document.querySelector(`.warranty-price-${variantId}`);
        if (warrantyPriceElement) {
          const priceText = warrantyPriceElement.textContent.trim();
          
          serviceProperties = {
            Parent: variantId,
            'Warranty Price': priceText,
            'Warranty Name': 'Pacifica_Monthly_Warranty_M1'
          };
        }
      }
      
      // Check if this is a monthly insurance service and add fixed price
      const serviceRow = document.querySelector(
        `.product-services-row [data-service-id="${serviceId}"]`
      )?.closest('.product-services-row');
      
      if (serviceRow) {
        const monthlyInsurancePrice = serviceRow.dataset.monthlyInsurancePrice;
        if (monthlyInsurancePrice) {
          serviceProperties = {
            ...serviceProperties,
            'Monthly price': '£4.99 per month'
          };
        }
      }

      items.push({
        id: serviceId,
        quantity: 1,
        properties: serviceProperties
      });
    });
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    const cart = await response.json();
    await showCartPopup();
  } catch (error) {
    console.error('Error:', error);
  }
}

async function showCartPopup() {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    await getCartItems(); // Wait for cart items to be fetched and displayed
    cartPopup.style.display = "block";
  }
}

// Add event listener for when favorites are loaded
document.addEventListener('favouritesLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.awo-add-product-button');

  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach(button => {
      // Existing click event listener
      button.addEventListener('click', async () => {
        const loader = button.querySelector('.loader-small');
        loader.style.display = 'inline-block';
        const variant = button.dataset.variant;
        // const inventoryStatus = button.dataset.inventoryStatus;
        const inventoryStatus = '';
        const properties = {
          Variant: variant,
          _InventoryStatus: inventoryStatus
        };
        try {
          await addProduct(variant, properties);
        } finally {
          loader.style.display = 'none'; // Hide the loader once the request is finished
        }
      });

      // New keydown event listener for keyboard accessibility
      button.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // Prevent the default action for Enter and Space keys
          const loader = button.querySelector('.loader-small');
          loader.style.display = 'inline-block';
          const variant = button.dataset.variant;
          const inventoryStatus = button.dataset.inventoryStatus;
          const properties = {
            Variant: variant,
            _InventoryStatus: inventoryStatus
          };
          try {
            await addProduct(variant, properties);
          } finally {
            loader.style.display = 'none'; // Hide the loader once the request is finished
          }
        }
      });
    });
  }
});